export enum NotificationType {
  AWB_STATUS_UPDATE = 'AWB_STATUS_UPDATE'
}
